/*
 * Author: Harper Yan
 * File Created: Wednesday, 25-01-22 10:58 am
 * Last Modified: Sunday, 25-01-26 04:22 pm, by Harper Yan
 */

import { LogoDCS } from './DCS';
import LogoDeCard from './DeCard';
import { LogoUnionPay, LogoUnionPay2 } from './UnionPay';

export const svgs = {
  LogoDeCard,
  LogoDCS,
  LogoUnionPay,
  LogoUnionPay2,
};

export type LogoType = keyof typeof svgs;
